@if (box$ | async; as box) {
  <div class="flex flex-col gap-12">
    <div class="grid lg:grid-cols-2">
      <div class="order-2 bg-gray-50 lg:order-1">
        <div
          class="flex flex-col overflow-y-auto bg-gray-50 lg:aspect-[650/658]">
          <div class="sticky top-0 bg-gray-50 px-8 pt-8 pb-4 xl:px-16 xl:pt-16">
            <h2 class="text-5xl uppercase">{{ box.name }}</h2>
            <div class="text-xl font-normal uppercase">
              @for (
                characteristic of box.characteristics;
                track characteristic.id;
                let index = $index, last = $last
              ) {
                <button
                  class="uppercase"
                  [class.active]="isActiveTab(index)"
                  (click)="handleTabClick(index)">
                  {{ characteristic.label }}
                </button>

                @if (!last) {
                  <span> | </span>
                }
              }
            </div>
          </div>

          <div class="flex flex-1 flex-col px-8 xl:px-16">
            <div class="text-sm">
              <app-summernote-html-preview
                [html]="box.characteristics[currentTabIndex()].content" />

              @if (isFirstTabActive()) {
                <div class="mt-8">
                  <div class="flex gap-1 font-bold">
                    <span class="uppercase">Cena:</span>
                    <app-currency [amount]="box.price" />
                  </div>
                </div>
              }
            </div>

            @if (isFirstTabActive()) {
              <div class="mt-auto">
                <div
                  class="leading-loose tracking-normal normal-case font-bold text-sm mt-8"
                >
                  Pamiętaj, że jeśli w danej edycji pojawi się możliwość samodzielnego wyboru
                  produktu lub jego wariantu, skorzystanie z tej opcji będzie możliwe wyłącznie
                  w&nbsp;przypadku dokonania zakupu z&nbsp;zalogowanego konta klienta.
                </div>

                <div class="flex gap-6 mt-4">
                  @if (false) {
                    <app-slim-button
                      maxWidth="16rem"
                      theme="dark"
                      label="Oceń edycję" />
                  }

                  <app-public-cart-add-button
                    label="Kup box"
                    maxWidth="16rem"
                    [sales]="box.sales" />
                </div>
              </div>
            }
          </div>

          <div
            class="sticky -bottom-px mt-auto h-12 w-full bg-gray-50 lg:aspect-[650/48] lg:h-auto"></div>
        </div>
      </div>

      <div class="order-1 lg:order-2">
        <div class="aspect-[650/164] py-5">
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="box.symbolAlt"
              [fill]="true"
              [ngSrc]="box.symbolSrc"
              class="object-scale-down"
              loading="lazy" />
          </app-image-thumbnail>
        </div>

        <div class="aspect-[650/446]">
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="box.illustrationAlt"
              [fill]="true"
              [ngSrc]="box.illustrationSrc"
              class="object-contain"
              loading="lazy" />
          </app-image-thumbnail>
        </div>

        <div
          class="flex h-12 w-full items-center justify-center bg-black text-center font-bold text-white uppercase lg:aspect-[650/48] lg:h-auto">
          @if (box.contentPreviewUrl) {
            <app-external-link
              [underline]="false"
              [link]="box.contentPreviewUrl">
              Zobacz co otrzymasz w swoim boxie
            </app-external-link>
          } @else {
            <div class="invisible">Zobacz co otrzymasz w swoim boxie</div>
          }
        </div>
      </div>
    </div>

    @if (box.groups.length > 0) {
      <div class="px-8 xl:px-16">
        <div class="mb-6 text-3xl font-bold uppercase">Grupy zawartości</div>

        <app-box-component-groups-preview
          [groups]="box.groups"
          [showAvailableQuantity]="false"
          [showRemainingQuantity]="false" />
      </div>
    }
  </div>
} @else {
  <app-spinner-filled />
}
